import type { DashCustomizationValue } from './DashCustomizationSection';

import { isValidHexColor } from '../../../utils/isValidHexColor/isValidHexColor';

/**
 * Personalização é tudo ou nada: com qualquer campo preenchido, exige cor
 * primária válida, secundária válida (quando não reaproveita a primária) e as
 * 3 imagens. O backend recusa payload incompleto antes de criar o tenant.
 *
 * Retorna `null` quando está ok ou quando nada foi preenchido (sem personalização).
 */
export function getDashCustomizationError(
  value: DashCustomizationValue,
  useSamePrimaryColor: boolean,
): string | null {
  const isFilled = Object.values(value).some((field) => !!field);
  if (!isFilled) return null;

  if (!isValidHexColor(value.primary_color)) {
    return 'Informe uma cor primária válida (ex: #f38a54)';
  }

  if (!useSamePrimaryColor && !isValidHexColor(value.secondary_color)) {
    return 'Informe uma cor secundária válida ou marque "Usar mesma cor primária"';
  }

  if (
    !value.logo_base64 ||
    !value.favicon_base64 ||
    !value.tenant_alias_image_base64
  ) {
    return 'Envie logo, favicon e ícone do tenant';
  }

  return null;
}
